import "./TagList.scss";
import block from "bem-cn";
import { useAppDispatch } from "../../app/hooks";
import React from "react";
import { addTagToList } from "../Filter/FilterSlice";

const b = block("TagList");

type Props = {
  text: string;
};

const TagList = ({ text }: Props) => {
  let tags: string[] = [];

  if (typeof text === "string") {
    tags = text.split(",").filter((item: string) => item.trim().length > 0);
  } else tags = text;

  const dispatch = useAppDispatch();

  const onHandleClickTag = (e: React.MouseEvent<HTMLSpanElement>) => {
    dispatch(addTagToList({ value: e.currentTarget.innerHTML.trim() }));
  };

  return (
    <ul className={b()}>
      {tags.map((tag, index) => (
        <li key={index} className={b("item")}>
          <span onClick={onHandleClickTag} className={b("tag")}>
            {tag}
          </span>
          {index < tags.length - 1 && <span>,&ensp;</span>}
        </li>
      ))}
    </ul>
  );
};

export default TagList;
